module.exports = __webpack_public_path__ + "img/e72fd8c.jpg";